import toggleMixin from "@/mixins/toggleMixin";
export default {
  name: "app-dialog",
  mixins: [toggleMixin],
  mounted() {}
};